import { AppDispatch } from "@Reducers/index";
import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import { setReviewFlowData, setReviewData } from "../reducers/ReviewFlows";
import type {
  GetReviewFlowDataRequest,
  GetReviewFlowDataResponse,
} from "@ServerTypes/reviewflows/reviewflows.schema.js";
import type { GetReviewDataRequest, GetReviewDataResponse } from "@ServerTypes/reviews/reviews.schema.js";

export function fetchReviewFlowData({ reviewFlowId }: { reviewFlowId: string }) {
  return async (dispatch: AppDispatch) => {
    const data: GetReviewFlowDataRequest = { id: reviewFlowId };
    const response = await axiosWrapper.post<GetReviewFlowDataResponse>(
      `${getBackendUrl()}/reviewflows/getReviewFlowData`,
      data,
    );

    if (response.data.status && response.data.result) {
      dispatch(setReviewFlowData(response.data.result));
    }
  };
}

export function fetchReviewData({ reviewId }: { reviewId: string }) {
  return async (dispatch: AppDispatch) => {
    const data: GetReviewDataRequest = { _id: reviewId };

    const response = await axiosWrapper.post<GetReviewDataResponse>(`${getBackendUrl()}/reviews/getReviewData`, data);

    if (response.data.status && response.data.result) {
      dispatch(setReviewData(response.data.result));
    }
  };
}
